import { createClient } from '@supabase/supabase-js';

// 首选从 Vite 环境变量读取；若未配置则回退到当前默认值
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://cttqfzhvlmycmswqbbpl.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN0dHFmemh2bG15Y21zd3FiYnBsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA0NjM3MTIsImV4cCI6MjA3NjAzOTcxMn0.6tYcQPWAWxyld1MB5JMbI4IAr9G2-cLqRDdIxyFE8Zc';


export const supabase = createClient(supabaseUrl, supabaseAnonKey);
